import { env } from '@/lib/config/env';
import { stripLeadingLocalePath } from '@/lib/network';

/** Pages that use the slim landing header instead of the full app chrome.
 *  Pre-launch the site root `/` serves the marketing landing page and uses
 *  the slim header; once launched it becomes the markets app and reverts to
 *  full app chrome. Strip only the locale — NOT the demo-mode prefix — so the
 *  devnet markets feed at `/demo-mode` keeps full app chrome (it must not
 *  collapse to `/`). */
export function isSimpleHeaderRoute(pathname: string): boolean {
  return (
    stripLeadingLocalePath(pathname) === '/' && env.NEXT_PUBLIC_EARLY_ACCESS_ENABLED === 'true'
  );
}
